module.exports = __webpack_public_path__ + "img/signup.80c14516.jpg";